// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal-module__backdrop___rPAJm","backdropColour":"modal-module__backdropColour___FJp15"};